import React, { useState, useEffect } from "react";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import styles from "../commanstyles.module.css";

function ContributionByBodyCorporatesTable({ isSubScribe, data }) {
  const [isTableOpen, setIsTableOpen] = useState(true);
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedYear, setSelectedYear] = useState("");
  
  const toggleTable = () => {
    setIsTableOpen((prev) => !prev);
  };

  // Get unique financial years from the data
  const getAvailableYears = () => {
    const years = Array.from(
      new Set(data.map((item) => item.financial_year))
    ).sort((a, b) => b - a); // Sort in descending order
    return years;
  };

  // Set the default selected year to the latest one when the component mounts
  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedYear(years[0]); // Set the latest year as default
    }
  }, [data]);

  // Filter data based on selected year
  const filteredData = data.filter((item) =>
    selectedYear ? item.financial_year == selectedYear : true
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className={styles.table_subcontainer}>
      {!isSubScribe ? (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      ) : (
        <>
          <div className={styles.highlet_header_content1}>
            <p className={styles.minuse_icon} onClick={toggleTable}>
              {isTableOpen ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>Contribution by Body Corporate(s)</h3>

            {/* Financial Year Dropdown */}
            {filteredData.length > 0 && (
              <div className={styles.yearSelectContainer}>
                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="">All Years</option>
                  {getAvailableYears().map((year) => (
                    <option key={year} value={year}>
                      {parseInt(year) - 1} - {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {isTableOpen && (
            <>
              <table className={styles.commantable}>
                <thead>
                  <tr className={styles.tableHeaderRow}>
                    <th className={styles.tableHeader}>SNo.</th>
                    <td className={styles.tableCell}>Name</td>
                    <th className={styles.tableHeader}>Nominee Name</th>
                    <th className={styles.tableHeader}>Obligation of Contribution (INR)</th>
                    <th className={styles.tableHeader}>Contribution Received (INR)</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((row, index) => (
                      <tr key={row.id} className={styles.tableRow}>
                        <td className={styles.tableCell}>{indexOfFirstRow + index + 1}</td>
                        <td className={styles.tableCell}>{row.name}</td>
                        <td className={styles.tableCell}>{row.nominee_name}</td>
                        <td className={styles.tableCell}>{row.obligation_of_contribution}</td>
                        <td className={styles.tableCell}>{row.contribution_received}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className={styles.noDataRow}>
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              <div className={styles.pagination}>
                <button onClick={handlePrevious} disabled={currentPage === 1}>
                  &lt;
                </button>
                {[...Array(totalPages).keys()].map((num) => (
                  <button
                    key={num + 1}
                    onClick={() => handleClick(num + 1)}
                    className={currentPage === num + 1 ? styles.active : ""}
                  >
                    {num + 1}
                  </button>
                ))}
                <button onClick={handleNext} disabled={currentPage === totalPages}>
                  &gt;
                </button>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default ContributionByBodyCorporatesTable;
